import { Dropdown, Image } from "antd"
import { APIConfig } from "@/config/common"

function AppDown(props) {
    return (
        <div>
            <Dropdown overlay={
                <Image width={255} height={255} src={`${APIConfig.FileUrl}/app/app.png`}></Image>
            }>
                <Image width={35} height={35} preview={false} src="/icons/android.png"></Image>
            </Dropdown>

        </div>
    )
}


export default AppDown
